import { useEffect, useState } from 'react';

const WEGLOT = window['Weglot'] || {};

export const useLanguage = (initial) => {
    const [currentLang, setCurrentLang] = useState(initial || '');

    const setLang = (lang) => {
        if (WEGLOT.switchTo) {
            WEGLOT.switchTo(lang);
        } else {
            window.postMessage(
                JSON.stringify({
                    type: 'sona-lang-change',
                    data: lang,
                })
            );
        }
    };

    useEffect(() => {
        if (WEGLOT.initialized) {
            setCurrentLang(WEGLOT.getCurrentLang());
        }
    }, [WEGLOT.initialized]);

    useEffect(() => {
        const handleMessage = (event) => {
            try {
                const message = JSON.parse(event.data);
                if (message.type === 'sona-lang-change') {
                    setCurrentLang(message.data);
                }
            } catch (e) {
                // Ignore invalid messages
            }
        };

        if (WEGLOT.on) {
            console.info('Using Weglot event listeners for language changes');

            WEGLOT.on('initialized', () => {
                setCurrentLang(initial || WEGLOT.getCurrentLang());
            });

            WEGLOT.on('languageChanged', (newLang, prevLang) => {
                if (WEGLOT.initialized) {
                    setCurrentLang(newLang);
                }
            });
        } else {
            if (initial) setLang(initial);

            console.info(
                'Using window message event listener for language changes'
            );
            window.addEventListener('message', handleMessage);
        }

        return () => {
            if (WEGLOT.off) {
                WEGLOT.off('initialized');
                WEGLOT.off('languageChanged');
            } else {
                window.removeEventListener('message', handleMessage);
            }
        };
    }, []);

    return { lang: currentLang, setLang };
};



// WEBPACK FOOTER //
// ./src/utils/useLanguage.js